export const SliderRightHandleSvg: string =
`<svg xmlns="http://www.w3.org/2000/svg" class="$state$" width="20" height="20">
  <style>
    .bg{fill:#fff}
    .outline{fill:#666}
    .focus .outline{fill:#3498db}
    .active .outline{fill:#333}
    .disabled .bg{fill:#ebebeb}
    .disabled .outline{fill:#b4b4b4}
  </style>
  <path class="bg" d="M7.8,2.6c4.3,0,7.8,3.3,7.8,7.4s-3.5,7.4-7.8,7.4H3.5V2.6H7.8z"/>
  <path class="outline" d="M4,3h3.6c4.1,0,7.4,3.1,7.4,7s-3.3,7-7.4,7H4V3 M3,2v16h4.6	c4.6,0,8.4-3.6,8.4-8s-3.7-8-8.4-8H3L3,2z"/>
</svg>`;
